import { FeatureFlags } from '@fabric-ui/components';
import { FormatterType } from '@fabric-ui/components/Table';
import { useAvContext } from '../../../context/AvContextProvider';
import { useCalculatedDimensionsList, useMeasurementsList } from '../../Reports/hooks';
import { FieldType } from '../../Sources/Mapping/types';
import { getFieldType } from '../getFieldType';

export const useGetFieldType = (activeProjName: string) => {
  const { accountEntities, featureFlags } = useAvContext();
  const { fieldTypeMap, aggProjs } = accountEntities;
  const { name: entityName } = aggProjs[activeProjName]?.entityTypeId ?? {};
  const { data: measurements = [] } = useMeasurementsList({
    entityName,
    filterFunc: v => v.context.includes(entityName),
  });

  const { data: calculatedDimensions = [] } = useCalculatedDimensionsList({
    projectionName: activeProjName,
    enabled: featureFlags[FeatureFlags.CalculatedDimensions],
  });

  return ({ entityFieldKey }: { entityFieldKey: string }): FormatterType | typeof FieldType.FIX | undefined =>
    getFieldType({
      entityFieldKey,
      measurements: [...measurements, ...calculatedDimensions],
      fieldTypeMap,
    });
};
